export default __webpack_public_path__ + "static/media/webTraderIcon5.6e7fe605.webp";